import type { SupportedLocale } from '@viamichelin/business';

export function matchGuardByLocaleAndDates(startDate: string, endDate: string, locale: SupportedLocale, enabledLocale: SupportedLocale) {
	if (!startDate || !endDate) {
		return false;
	}

	const currentDate = new Date();
	return locale === enabledLocale && currentDate > new Date(startDate) && currentDate < new Date(endDate);
}
